import AxiosClient from "../../../services/axios.services";

class AssignCompetenciesServices {
  getAssignCompetencies = (params) =>
    AxiosClient.get("/api/app/descriptor_perfil_competencia_descriptor/", {
      headers: { "Content-Type": "application/json" },
      params: params,
    });

  getAssignCompetenciesById = (id) =>
    AxiosClient.get(`/api/app/descriptor_perfil_competencia_descriptor/${id}/`, {
      headers: { "Content-Type": "application/json" },
    });

  saveAssignCompetencies = (data) =>
    AxiosClient.post("/api/app/descriptor_perfil_competencia_descriptor/", data, {
      headers: { "Content-Type": "application/json" },
    });

  editAssignCompetencies = (id, data) =>
    AxiosClient.put(`/api/app/descriptor_perfil_competencia_descriptor/${id}/`, data, {
      headers: { "Content-Type": "application/json" },
    });

  deleteAssignCompetencies = (id) =>
    AxiosClient.delete(`/api/app/descriptor_perfil_competencia_descriptor/${id}`, {
      headers: { "Content-Type": "aplication/json" },
    });

    mailSendGeneralInfo = (data) =>
    AxiosClient.post("/api/app/descriptor_perfil_envio_correo/", data, {
      headers: { "Content-Type": "application/json" },
    });
}

export default new AssignCompetenciesServices();